module.exports = __webpack_public_path__ + "static/media/splash.ae46ae77.png";